import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

import orenge from "../../image/orenge.jpg"
import green from "../../image/green.jpg"
import white from "../../image/white.jpg"
import voice from "../../image/voice.jpg"
import individ from "../../image/individ.jpg"

const IntroRooms = () => {

   return (
      <IntroRoomsStyles
         id="rooms"
         orenge={orenge}
         green={green}
         white={white}
         voice={voice}
         individ={individ}
      >
         <h3>教室紹介</h3>
         <div className="rooms">
            <div className="room orenge">
               <h4>オレンジの教室</h4>
            </div>
            <div className="room green">
               <h4>グリーンの教室</h4>
            </div>
            <div className="room white">
               <h4>ホワイトの教室</h4>
            </div>
            <div className="room voice">
               <h4>音読・リスニングルーム</h4>
            </div>
            <div className="room individ">
               <h4>自習室</h4>
            </div>
         </div>
      </IntroRoomsStyles>
   )
}

const IntroRoomsStyles = styled.section`
   background-color: #FF8787;
   h3 {
      color: #fff;
   }
   .rooms {
      width: 100%;
      max-width: 1580px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      ${media.lessThan("600px")`
         flex-direction: column;
         align-items: center;
         justify-content: none;
      `}
      .room {
         width: 30%;
         max-width: 400px;
         height: 300px;
         margin-top: 60px;
         background: #FF3D01 0% 0% no-repeat padding-box;
         box-shadow: 10px 10px 0px #0000008C;
         ${media.lessThan("960px")`
            width: 40%;
         `}
         ${media.lessThan("600px")`
            width: 90%;
            height: 240px;
            margin-top: 24px;
         `}
         &:before {
            content: "";
            display: block;
            height: 260px;
            width: 100%;
            background-size: cover;
            ${media.lessThan("600px")`
               height: 200px;
            `}
         }
         h4 {
            height: 40px;
            font-size: 1.8rem;
            line-height: 40px;
            text-align: center;
            color: #fff;
         }
      }

      .orenge {
         &:before {
            background-image: url(${({orenge}) => orenge});
         }
      }  
      .green {
         &:before {
            background-image: url(${({green}) => green});
         }
      }
      .white {
         &:before {
            background-image: url(${({white}) => white});
         }
      }
      .voice {
         &:before {
            background-image: url(${({voice}) => voice});
         }
      }
      .individ {
         &:before {
            background-image: url(${({individ}) => individ});
         }
      }
   }
` 

export default IntroRooms